import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";

import "./style.scss";

const ColorPicker = ({ options, selectedOption, onChange = () => {} }) => {
  const [currentSelectedOption, setCurrentSelectedOption] = useState(selectedOption);

  const handleOnChange = (evt, option) => {
    setCurrentSelectedOption(option);
    onChange(evt, option);
  };

  const selectWithKeyboardKeys = (event, option) => {
    const SPACE = 32;
    const ENTER = 13;
    if (event.keyCode === SPACE || event.keyCode === ENTER) {
      event.preventDefault();
      handleOnChange(event, option);
    }
  };

  return (
    <div className="color-picker">
      <div className="options">
        {options &&
          options.map((option, index) => (
            <div key={`${option.label}-${index}`} className="option-container">
              <div
                className={classNames("option", {
                  active: option === currentSelectedOption,
                  "sold-out": option.soldOut
                })}
                onClick={evt => !option.soldOut && handleOnChange(evt, option)}
                onKeyDown={event => !option.soldOut && selectWithKeyboardKeys(event, option)}
                tabIndex="0"
              >
                {option.soldOut && (
                  <span className="sold-out">
                    <span className="bar" />
                  </span>
                )}
                <span className="option__content" tabIndex="-1">
                  <img src={option.image.src} alt={option.image.alt}></img>
                </span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

ColorPicker.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      image: PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string })
    })
  ),
  selectedOption: PropTypes.shape({
    label: PropTypes.string,
    image: PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string })
  }),
  onChange: PropTypes.func
};

ColorPicker.defaultProps = {
  onChange: () => {}
};

export default ColorPicker;
